(function () {
  if (window.__igStickyCtaInit) return;
  window.__igStickyCtaInit = true;

  function init() {
    const root = document.querySelector('[data-ig-sticky-cta]');
    if (!root) return;

    const { targetSelector, buyboxSelector, activeSelector, titleOverride, subtitleOverride, context } = root.dataset;
    const titleEl = root.querySelector('[data-ig-sticky-title]');
    const subEl   = root.querySelector('[data-ig-sticky-subtitle]');
    const btnEl   = root.querySelector('[data-ig-sticky-btn]');
    let showing = false;

    function findTarget() {
      const nodes = [...document.querySelectorAll(targetSelector)];
      return nodes.find(n => n.textContent.trim().toLowerCase().includes('pick your flavors')) ?? nodes[0] ?? null;
    }

    function readActiveOption() {
      const li = document.querySelector(activeSelector);
      if (!li) return null;
      return {
        title:    li.querySelector('.option-info .option-title')?.textContent.trim() ?? '',
        subtitle: li.querySelector('.option-info small')?.textContent.trim() ?? '',
        url:      li.getAttribute('data-url') ?? ''
      };
    }

    function syncCopy() {
      const data       = readActiveOption();
      const finalTitle = titleOverride    || data?.title    || '';
      const finalSub   = subtitleOverride || data?.subtitle || '';
      titleEl.textContent = finalTitle;
      subEl.textContent   = finalSub;
      root.classList.toggle('ig-sticky-cta--no-copy', !finalTitle && !finalSub);
    }

    function show() {
      if (showing) return;
      showing = true;
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-visible');
    }

    function hide() {
      if (!showing) return;
      showing = false;
      root.classList.remove('is-visible');
      setTimeout(() => { if (!showing) root.hidden = true; }, 300);
    }

    function handleClick(e) {
      e.preventDefault();

      if (context === 'lp') {
        const buybox = document.querySelector(buyboxSelector);
        (buybox || findTarget())?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      if (document.querySelector(buyboxSelector)) {
        const url = readActiveOption()?.url || findTarget()?.getAttribute('data-url');
        if (url) window.location.href = url;
      } else {
        findTarget()?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    function setupVisibility() {
      const target = findTarget();
      if (!target) return;

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(([entry]) => {
          entry.isIntersecting ? hide() : show();
        }, { threshold: 0 }).observe(target);
      } else {
        const check = () => {
          const { bottom, top } = target.getBoundingClientRect();
          bottom > 0 && top < window.innerHeight ? hide() : show();
        };
        window.addEventListener('scroll', check, { passive: true });
        window.addEventListener('resize', check);
        check();
      }
    }

    function setupMutationObserver() {
      const ul = document.querySelector(buyboxSelector);
      if (!ul) return;
      new MutationObserver(syncCopy).observe(ul, {
        subtree: true, attributes: true, attributeFilter: ['class']
      });
    }

    btnEl.addEventListener('click', handleClick);
    setupVisibility();
    if (document.querySelector(buyboxSelector)) setupMutationObserver();
    syncCopy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
